import { createSelector } from 'reselect'

export const tidesSelector = state => state.tides

export const getSingleTideDataSelector = tideStationUuid =>
  createSelector(
    tidesSelector,
    tides => tides[tideStationUuid]
  )
